export interface DestinyMatrix {
  r1: MatrixLayer;
  r2: MatrixLayer;
  r3: MatrixLayer;
  middle_points: MiddlePoints;
  right_corner: RightCorner;
  personal: PersonalComponent;
  years: number[][];
  center: number;
}

export interface MatrixLayer {
  l: number;
  tl: number;
  t: number;
  tr: number;
  r: number;
  br: number;
  b: number;
  bl: number;
}

export interface MiddlePoints {
  l: number;
  t: number;
  r: number;
  right_center: number;
}

export interface RightCorner {
  l: number;
  r: number;
  c: number;
}

export interface RelativeMatrixPoint {
  id: number;
  matrixKey: string;
  r: number;
  rx: number;
  ry: number;
  fill: string;
  textColor: string;
  textSize: number;
  border: string;
}

export interface MatrixDescription {
  first: string;
  second: string | undefined;
  third: string;
}

export interface PersonalComponent {
  m: number;
  f: number;
  social: number;
  h: number;
  e: number;
  personal: number;
  harmony: number;
  planetary: number;
}

export enum DestinyMatrixKeysEnum {
  FAMILY_POWER = "family_power",
  PERSONAL_CHARACTERISTICS = "personal_characteristics",
  SELF_REALIZATION = "self_realization",
  SPIRIT_COMPORT_POINT = "spirit_comport_point",
  VACATION = "vacation",

  // Premium
  ALCOHOL_PRONE = "alcohol_prone",
  PARENT_CHILD_KARMA = "parent_child_karma",
  FAMILY_TASKS_7_GENERATION = "family_tasks_7_generation",
  EXCESS_WEIGHT_IN_MATRIX = "excess_weight_in_matrix",
  GETTING_REACH_BY_BIRTH_YEAR = "getting_reach_by_birth_year",
  KARMA_AND_40_YEARS_TASKS = "karma_and_40_years_tasks",
  MONEY_IN_MATRIX = "money_in_matrix",
  PERSONAL_POINT_OF_POWER = "personal_point_of_power",
  PREVIOUS_LIVES_TASKS = "previous_lives_tasks",
  PURPOSES = "purposes",
  RELATIONS_IN_MATRIX = "relations_in_matrix",
  SPIRIT_KARMA = "spirit_karma",
  WHAT_GIVES_YOU_RESOURCE = "what_gives_you_resource",
  WHOM_WORKS_FOR_SOUL = "whom_works_for_soul",
  HEALTH_MAP = "health_map",
  PROGRAMS = "programs",
  PREDISPOSITION_TO_DISEASES = "predisposition_to_diseases",
  YEAR_TASKS = "year_tasks",
}

export const PREMIUM_KEYS_SET = new Set<DestinyMatrixKeysEnum>([
  DestinyMatrixKeysEnum.ALCOHOL_PRONE,
  DestinyMatrixKeysEnum.PARENT_CHILD_KARMA,
  DestinyMatrixKeysEnum.FAMILY_TASKS_7_GENERATION,
  DestinyMatrixKeysEnum.EXCESS_WEIGHT_IN_MATRIX,
  DestinyMatrixKeysEnum.GETTING_REACH_BY_BIRTH_YEAR,
  DestinyMatrixKeysEnum.KARMA_AND_40_YEARS_TASKS,
  DestinyMatrixKeysEnum.MONEY_IN_MATRIX,
  DestinyMatrixKeysEnum.PERSONAL_POINT_OF_POWER,
  DestinyMatrixKeysEnum.PREVIOUS_LIVES_TASKS,
  DestinyMatrixKeysEnum.PURPOSES,
  DestinyMatrixKeysEnum.RELATIONS_IN_MATRIX,
  DestinyMatrixKeysEnum.SPIRIT_KARMA,
  DestinyMatrixKeysEnum.WHAT_GIVES_YOU_RESOURCE,
  DestinyMatrixKeysEnum.WHOM_WORKS_FOR_SOUL,
  DestinyMatrixKeysEnum.HEALTH_MAP,
  DestinyMatrixKeysEnum.PROGRAMS,
  DestinyMatrixKeysEnum.PREDISPOSITION_TO_DISEASES,
]);
